module.exports = __webpack_public_path__ + "img/ic_service_item_img2.29e3db46.png";